import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-opacity": ".2",
      d: "m8.162 7.5 3.89-3.885a.474.474 0 0 0-.667-.668L7.5 6.837l-3.885-3.89a.475.475 0 0 0-.668.668L6.837 7.5l-3.89 3.885a.475.475 0 0 0 0 .668.48.48 0 0 0 .668 0L7.5 8.163l3.885 3.89a.48.48 0 0 0 .668 0 .474.474 0 0 0 0-.668z"
    }, null, -1)
  ])))
}
export default { render: render }